import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import "./RegisterCheckData.css";
import { useHelper } from "../../context/Helper";
import { useRegisterState } from "../../_store/Register";
import { useClientState } from "../../_store/Client";
import InputFieldComponent, {
  InputMode,
} from "../../components/common/InputField";
import Spinner from "../../components/spinners/Spinner";
import { Input, Button, SelectPicker, Message, useToaster } from "rsuite";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  RegisterUserFromProps,
  FindWithPhoneProps,
} from "../../_types/Register";
import moment from "moment-timezone";
import _ from "lodash";

import JsonViewerComponent from "../../components/common/JsonViewerComponent";
import { useAuth } from "../../context/UseAuth";
import { AuthProfileProps } from "../../_types/Client";
import { maskName } from "../../utils/nameUtils";
import { useLoginState } from "../../_store/Login";

const MySwal = withReactContent(Swal);
const messageError = (msg: String) => (
  <Message showIcon type={"error"} closable>
    <strong>แจ้งเตือน!</strong> {msg}
  </Message>
);
const RegisterCheckData = ({
  isSetRegister,
}: {
  isSetRegister: (isRegister: boolean) => void;
}) => {
  const { t, i18n } = useTranslation("register");
  const toaster = useToaster();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { getMessage } = useHelper();
  const isLoading = useRegisterState((state) => state.isLoading);
  const setIsLoading = useRegisterState((state) => state.setIsLoading);
  const validationRequestOtpData = useRegisterState(
    (state) => state.validationRequestOtpData
  );
  const clientLogin = useLoginState((state) => state.clientLogin);
  const { loginUser, logout } = useAuth();
  const findWithPhone = useRegisterState((state) => state.findWithPhone);
  const dayOptions = useClientState((state) => state.dayOptions);
  const monthOptions = useClientState((state) => state.monthOptions);
  const getCaseByClientId = useClientState((state) => state.getCaseByClientId);

  const methods = useForm<RegisterUserFromProps>({
    mode: "onChange",
    resolver: yupResolver(validationRequestOtpData(t)),
    defaultValues: undefined,
  });
  const {
    formState: { errors },
    getValues,
    watch,
    setValue,
    reset,
    trigger,
  } = methods;

  const onRequestCheckData: SubmitHandler<RegisterUserFromProps> = async (
    data
  ) => {
    setIsLoading(true);
    await findWithPhone(data.telephoneNumber)
      .then(async (res: ResponseProps) => {
        if (res.data?.code === 200) {
          if (res.data?.status === true) {
            var dataFindWithPhone = res.data.output.data as FindWithPhoneProps;
            var isDuplicate = dataFindWithPhone.isDuplicate;
            if (isDuplicate === false) {
              localStorage.setItem("check_phone", data.telephoneNumber || "");
              localStorage.setItem("check_dOfBirth", data.dOfBirth || "");
              localStorage.setItem("check_mOfBirth", data.mOfBirth || "");
              localStorage.setItem("check_yOfBirth", data.yOfBirth || "");
              isSetRegister(true);
              setIsLoading(false);
            } else {
              await clientLogin(
                data.telephoneNumber,
                moment
                  .tz(
                    `${data.yOfBirth}-${data.mOfBirth}-${data.dOfBirth}`,
                    "Asia/Bangkok"
                  )
                  .format("YYYY-MM-DD"),
                "+66"
              )
                .then(async (response: ResponseProps) => {
                  if (response.data?.code === 200) {
                    if (response.data?.status === true) {
                      await loginUser(response);
                      const profile = JSON.parse(
                        localStorage.getItem("profile") || ""
                      ) as AuthProfileProps;

                      // เพิ่มขั้นตอนตรวจสอบว่าเป็นเคสนัดกลับมาหรือไม่
                      let isNewAppointment: boolean = false;
                      await getCaseByClientId(profile.id).then((res_case) => {
                        console.log("res_case", res_case);
                        if (
                          res_case.data?.code === 200 &&
                          res_case.data.status === true
                        ) {
                          let cases = (res_case.data.output.data || []).filter(
                            (a: any) => a.masterStatusCode === "D151-04"
                          );
                          if (cases.length > 0) {
                            isNewAppointment = true;
                          }
                        }
                      });

                      if (isNewAppointment) {
                        MySwal.fire({
                          icon: "error",
                          html: `${t("login:alert.newAppointment")}`,
                          confirmButtonText: `${t("login:btn.btnVerLogin")}`,
                          confirmButtonColor: "#3085d6",
                          allowOutsideClick: false,
                          allowEscapeKey: false,
                        }).then((result) => {
                          logout();
                        });
                      } else {
                        toaster.push(
                          <Message showIcon type={"success"} closable>{`${t(
                            "alert.loginSuccess"
                          )} ${maskName(profile.fullName)}`}</Message>,
                          { duration: 5000 }
                        );
                        if ((searchParams.get("ref") || "") != "") {
                          navigate(
                            `/changeappointment?ref=${
                              searchParams.get("ref") || ""
                            }`
                          );
                        } else {
                          navigate("/changeappointment");
                        }
                      }
                    } else {
                      MySwal.fire({
                        icon: "error",
                        text: `${t("login:alert.loginTitle")}`,
                        showCancelButton: true,
                        confirmButtonText: `${t("login:btn.btnReCheck")}`,
                        cancelButtonText: `${t("login:btn.btnCancel")}`,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        reverseButtons: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                      }).then((result) => {
                        if (result.isConfirmed) {
                        } else if (
                          result.dismiss === Swal.DismissReason.cancel
                        ) {
                          if ((searchParams.get("ref") || "") != "") {
                            navigate(`/?ref=${searchParams.get("ref") || ""}`);
                          } else {
                            navigate("/");
                          }
                        }
                      });
                    }
                  } else {
                    toaster.push(messageError(getMessage(response)), {
                      duration: 5000,
                    });
                  }
                  setIsLoading(false);
                })
                .catch((error) => {
                  toaster.push(messageError(JSON.stringify(error)), {
                    duration: 5000,
                  });
                  setIsLoading(false);
                });

              // MySwal.fire({
              //     icon: 'error',
              //     text: `${t("registerOtp.alert.checkData")}`,
              //     showCancelButton: true,
              //     confirmButtonText: `${t("registerOtp.btn.btnReCheck")}`,
              //     cancelButtonText: `${t("registerOtp.btn.btnCancel")}`,
              //     confirmButtonColor: '#3085d6',
              //     cancelButtonColor: '#d33',
              //     reverseButtons: true,
              //     allowOutsideClick: false,
              //     allowEscapeKey: false,
              // }).then((result) => {
              //     if (result.isConfirmed) {
              //     } else if (result.dismiss === Swal.DismissReason.cancel) {
              //         if ((searchParams.get('ref') || "") != "") {
              //             navigate(`/?ref=${searchParams.get('ref') || ""}`);
              //         } else {
              //             navigate('/');
              //         }
              //     }
              //     setIsLoading(false);
              // });
            }
          } else {
            MySwal.fire({
              icon: "error",
              text: `${getMessage(res)}`,
              showCancelButton: true,
              confirmButtonText: `${t("registerOtp.btn.btnReCheck")}`,
              cancelButtonText: `${t("registerOtp.btn.btnCancel")}`,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              reverseButtons: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.isConfirmed) {
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                if ((searchParams.get("ref") || "") != "") {
                  navigate(`/?ref=${searchParams.get("ref") || ""}`);
                } else {
                  navigate("/");
                }
              }
              setIsLoading(false);
            });
          }
        } else {
          toaster.push(messageError(getMessage(res)), { duration: 5000 });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toaster.push(messageError(JSON.stringify(error)), { duration: 5000 });
        setIsLoading(false);
      });
  };
  const onCancel = () => {
    localStorage.removeItem("check_phone");
    localStorage.removeItem("check_dOfBirth");
    localStorage.removeItem("check_mOfBirth");
    localStorage.removeItem("check_yOfBirth");
    var defaultData: RegisterUserFromProps = {
      telephoneNumber: "",
      dOfBirth: undefined,
      mOfBirth: undefined,
      yOfBirth: undefined,
    };
    reset({ ...defaultData });
    if ((searchParams.get("ref") || "") != "") {
      navigate(`/register?ref=${searchParams.get("ref") || ""}`);
    } else {
      navigate("/register");
    }
  };

  useEffect(() => {
    setIsLoading(true);
    var gettingData = true;
    if (gettingData) {
      setIsLoading(false);
    }
    return () => {
      gettingData = false;
    };
  }, []);

  return (
    <FormProvider {...methods}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="card mb-3">
            <div className="card-body">
              <div className="mb-3 mt-4">
                <InputFieldComponent
                  name="telephoneNumber"
                  require={true}
                  label={t("registerOtp.form.telephoneNumber")}
                  mode={InputMode.secondary}
                  labelAlignClassName="text-left"
                  labelClassName="col-sm-12"
                  inputClassName="col-sm-12"
                  renderControl={(field) => (
                    <Input
                      type={"tel"}
                      {...field}
                      maxLength={20}
                      autoComplete="off"
                    />
                  )}
                ></InputFieldComponent>
              </div>
              <div className="mb-3">
                <div className="row">
                  <div className="col-sm-12 col-md-4">
                    <InputFieldComponent
                      name="dOfBirth"
                      require={true}
                      label={t("registerOtp.form.dOfBirth")}
                      mode={InputMode.secondary}
                      labelAlignClassName="text-left"
                      labelClassName="col-sm-12"
                      inputClassName="col-sm-12"
                      renderControl={(field) => (
                        <SelectPicker
                          {...field}
                          className="w-100"
                          data={(dayOptions || []).map((a) => {
                            return {
                              value: a.value,
                              label: a.label,
                            } as OptionProps;
                          })}
                          onChange={(value, e) => {
                            setValue("dOfBirth", value);
                          }}
                        />
                      )}
                    ></InputFieldComponent>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <InputFieldComponent
                      name="mOfBirth"
                      require={true}
                      label={t("registerOtp.form.mOfBirth")}
                      mode={InputMode.secondary}
                      labelAlignClassName="text-left"
                      labelClassName="col-sm-12"
                      inputClassName="col-sm-12"
                      renderControl={(field) => (
                        <SelectPicker
                          {...field}
                          className="w-100"
                          data={(monthOptions || []).map((a) => {
                            return {
                              value: a.value,
                              label:
                                i18n.language === "th"
                                  ? a.labelTh
                                  : i18n.language === "en"
                                  ? a.labelEn
                                  : a.labelTh,
                            } as OptionProps;
                          })}
                          onChange={(value, e) => {
                            setValue("mOfBirth", value);
                          }}
                        />
                      )}
                    ></InputFieldComponent>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <InputFieldComponent
                      name="yOfBirth"
                      require={true}
                      label={t("registerOtp.form.yOfBirth")}
                      mode={InputMode.secondary}
                      labelAlignClassName="text-left"
                      labelClassName="col-sm-12"
                      inputClassName="col-sm-12"
                      renderControl={(field) => (
                        <SelectPicker
                          {...field}
                          className="w-100"
                          data={(() => {
                            const options = [] as OptionProps[];

                            for (
                              let i = 1900;
                              i <= moment().tz("Asia/Bangkok").year();
                              i++
                            ) {
                              options.push({
                                value: _.toString(i),
                                label:
                                  i18n.language === "th"
                                    ? _.toString(i + 543)
                                    : i18n.language === "en"
                                    ? _.toString(i)
                                    : _.toString(i + 543),
                              } as OptionProps);
                            }

                            return options;
                          })()}
                          onChange={(value, e) => {
                            setValue("yOfBirth", value);
                          }}
                        />
                      )}
                    ></InputFieldComponent>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Button
                    color="red"
                    appearance="primary"
                    className="w-100"
                    onClick={() => {
                      onCancel();
                      if ((searchParams.get("ref") || "") != "") {
                        navigate(`/?ref=${searchParams.get("ref") || ""}`);
                      } else {
                        navigate("/");
                      }
                    }}
                  >
                    {t("registerOtp.btn.btnCancel")}
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    color="green"
                    appearance="primary"
                    className="w-100"
                    onClick={async () => {
                      const isValid = await trigger();
                      if (isValid) {
                        onRequestCheckData(getValues());
                      }
                    }}
                  >
                    {t("registerOtp.btn.btnRequestCheckPhone")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <JsonViewerComponent data={watch()}></JsonViewerComponent>
      <JsonViewerComponent data={errors}></JsonViewerComponent>
    </FormProvider>
  );
};

export default RegisterCheckData;
